<template>
    <div class="bottom">
        <img class="bottombg" src="../assets/bottom_bg.png" alt="">
        <div class="center_bottom">
        <div class="bottomContent">
            <div class="bottomTop">
                <div class="bottomItem" v-for="(item,index) in dataList" :key="index">
                    <div class="ulTop">{{item.name}}</div>
                    <div class="divider"></div>
                    <ul>
                        <li v-for="(sub,sIndex) in item.childs" :key="sIndex" @click="onClick(item,sub)">
                            <router-link
                                class="ulListColor"
                                :to="{ path: sub.href?sub.href:'/contentPage', query: { code:sub.menuCategory}}"
                                >{{sub.name}}
                            </router-link>
                        </li>
                    </ul>
                </div>
                
                <div class="bottomOA">
                    <div>
                        <img
                            src="@/assets/resume.jpg"
                            width="153"
                            height="153"
                        />
                        <div class="oaFont">关注公众号</div>
                    </div>
                </div>
            </div>
            <div class="bottomBtm">
                <div class="divider"></div>

                <div class="copyRight">  
                    <div>
                        {{info.cfgZbaddr}}  邮箱：{{info.hrEmail}}  联系电话：{{info.hrTel}}
                    </div>
                    <a href="https://beian.miit.gov.cn"
                        >{{ info.cfgPowerby }}&nbsp;{{ info.cfgBeian }}</a
                    >
                </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import { getAction } from "@/api/services";
export default {
    name: "Bottom",
    data() {
        return {
            url: "/jhwlweb/gwweb/cmsBaseinfo/queryById",
            info: {},
            dataList:[],
        };
    },
    computed : {

    },
    created() {
        this.getMenuData();
        // if(sessionStorage.getItem("menuInfo")){
        //     this.dataList =  JSON.parse(sessionStorage.getItem("menuInfo"));
        // }
        this.getInfo();
    },
    methods: {
        getMenuData(){
            let that = this;
            getAction("/jhwlweb/gwweb/cmsArticleCategory/queryAllCategory")
            .then((res) => {
                if (res.code == 200 && res.success) {
                    this.dataList = res.result;
                }
            });
        },
        getInfo() {
            let that = this;
            getAction(that.url).then((res) => {
                if (res.code == 200 && res.success) {
                    that.info = res.result;
                }
            });
        },
        onClick(item,sub){
            var obj={
                activeItem:item.childs,
                activeSubId:sub.id
            }
            sessionStorage.setItem("activeMenu",JSON.stringify(item)); 

            var path = sub.href?sub.href:"/contentPage";
            var code = sub.menuCategory;
            window.location.href=path+"?code="+code;
        },
    },
};
</script>

<style scoped lang="less">
.ulListColor {
    color: #666666;
    &:hover{
        color: #333;
        font-weight: bold;
    }
}
.bottom {
    position: relative;
    width: 1300px;
    margin: 0 auto;
    position: relative;
    // background-color: black;
    // background: url("../assets/bottom_bg.png") no-repeat;
    // background-size: cover;
    .bottombg{
        width: 1920px;
        margin: 0 auto;
        display: block;
        margin-left: -310px;
    }
    .center_bottom{
        position: absolute;
        top: 0;
        left: 0;
         width: 100%;
    }
    .bottomContent {
        margin: 0 auto;
        width: 1100px;
        padding: 50px 0 20px;   
        .bottomTop {
            display: flex;
            justify-content: space-between;
            height: 290px;
            // padding-bottom: 20px;
            .bottomItem {
                .ulTop {
                    color:#333333;
                    font-size: 18px;
                    font-weight: bold;
                }
                .divider {
                    margin-top: 12px;
                    margin-bottom: 22px;
                    width: 33px;
                    height: 1px;
                    background-color: #333333;
                }
                ul {
                    padding: 0;
                    color: #999;
                    list-style: none;
                    font-size: 16px;
                    li {
                        padding-bottom: 12px;
                    }
                }
            }
        }
        .bottomMid {
            margin-top: -40px;
            padding-left: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .bottomInfo {
                .bottomInfoContent {
                    display: flex;
                    align-items: center;
                    div {
                        margin-left: 18px;
                        font-size: 22px;
                        color: #ffffff;
                    }
                }
            }
        }
        .bottomBtm {
            .divider {
                border-bottom: 1px solid #fff;
            }
            .copyRight {
                margin-top: 30px;
                text-align: center;
                font-size: 14px;
                color: #666;
                a{
                    color: #666;
                }
            }
        }
    }
    .bottomOA {
        display: flex;
        border-left: 1px solid #fff;
        padding-left: 60px;
        div {
            .oaFont {
                color: #333;
                margin-top: 20px;
                margin-bottom: 30px;
                font-size: 16px;
                text-align: center;
            }
        }
    }
}
</style>
